<template>
  <div class="compcont"
  :grc_shownoti="shownoti"
  :grc_maxfiles="maxfiles"
  :grc_allowed_extensions="allowed_extensions"
  :grc_manual_delete_enabled="manual_delete_enabled"
  :grc_manual_add_enabled="manual_add_enabled"
  >
    <GrcDB ref="GRCDB"></GrcDB>    
    <GrcDocUtils ref="DocUtils"></GrcDocUtils>
    <GrcDocDisplayer ref="DocDisplayer"></GrcDocDisplayer>
    <GrcDialog ref="Dialog"></GrcDialog>


            <div class="filelist_cont">
                <div class="file_for" v-for="(item, index)  in THUMBNAILS" v-bind:key="index">
                    <div class="file_delete" v-show="manual_delete_enabled=='true'" @click="DeleteFile(index)"><i class="fa-light fa-trash-alt"></i></div>                    
                    <table class="file_thumb" @click="ShowFile(index)" cellspacing="0" cellpadding="0">
                        <tr>
                            <td v-bind:style="{ 'padding-bottom': item.Ext=='pdf' ? '20px' : '0px' }">
                                <img :src="item.Img" style="border: solid 1px #aaa;" />
                            </td>
                        </tr>
                    </table>

               
                    <div class="file_footer">
                        <div class="file_filename grc-noselect">{{item.FileName}}</div>
                        <div class="file_filesize grc-noselect">{{item.FileSize}}</div>
                    </div>
                </div>

                <div class="file_for_drag" v-show="((THUMBNAILS.length<parseInt(maxfiles))||(maxfiles=='-1'))&&(manual_add_enabled=='true')">

                    <div class="drag_text" @drop="OpenLocalFileDrop" @dragover="FileDragOver" @dragleave="FileDragLeave" @dragstart="FileDragStart">
                        Húzza ide a fájlokat a feltöltéshez!<br><br>Engedélyezett típusok:<br>{{allowed_extensions}}
                        <span v-show="maxfiles!='-1'"><br><br>Max. {{maxfiles}} fájl tölthető fel!</span>
                    </div>

                    <div class="btncont" style="margin: 10px 0px;">
                        <label class="btn grc-noselect">
                            <i class="fa-light fa-plus btn_icon" style="font-size: 10px; margin-right:14px;"></i><span class="btn_text">Fájlok kiválasztása</span>
                            <input ref="fileinput" type="file" multiple accept="image/jpeg,application/pdf" @change="OpenLocalFile"
                                style="width: 0.1px; height: 0.1px; opacity: 0;	overflow: hidden; position: absolute; z-index: -1;"
                            >
                        </label>
                    </div>
                </div>
            </div>



            <GrcTextArea ref="txtMegjegyzes" v-show="shownoti=='true'"
            grc_labeltext="Megjegyzés:" grc_labelmode="above" grc_labelwidth="200px" 
            grc_areaheight="100px"
            style="margin-top:10px;"
            />


  </div>
</template>

<script>

import Vue from 'vue'
import GrcText from '../GrcComponents/GrcText.vue'
import GrcButton from '../GrcComponents/GrcButton.vue'
import GrcDB from '../GrcComponents/GrcDB.vue'
import GrcDialog from '../GrcComponents/GrcDialog.vue'
import GrcDocDisplayer from '../GrcComponents/GrcDocDisplayer.vue'
import GrcTextArea from '../GrcComponents/GrcTextArea.vue'
import GrcDocUtils from '../GrcComponents/GrcDocUtils.vue'


export default {
  name: 'GrcDocMultiSelect',
  components:
  {
      GrcButton,
      GrcDB,
      GrcDialog,
      GrcText,
      GrcDocDisplayer,
      GrcTextArea,
      GrcDocUtils,

  },
  props: {
    grc_shownoti: String,
    grc_maxfiles: String,
    grc_allowed_extensions: String,
    grc_manual_delete_enabled: String,
    grc_manual_add_enabled: String
  },
  data () {
    return {

        shownoti: this.grc_shownoti,
        maxfiles: this.grc_maxfiles,
        allowed_extensions: this.grc_allowed_extensions,
        manual_delete_enabled: this.grc_manual_delete_enabled,
        manual_add_enabled: this.grc_manual_add_enabled,

        EREDETIDOKLIST: [],
        KONVERTDOKLIST: [],
        THUMBNAILS:[],
        FILETEMPDOCS:[],

        MaxWidth:2000,
        MaxHeight:3000,

        ThumbnailWidth:300,
        ThumbnailHeight:200,


    }
  },
  watch : {
  },



  created: function()
  {
    if (typeof this.shownoti == "undefined")
    {
      this.shownoti = "true";
    }

    if (typeof this.manual_delete_enabled == "undefined")
    {
      this.manual_delete_enabled = "true";
    }

    if (typeof this.manual_add_enabled == "undefined")
    {
      this.manual_add_enabled = "true";
    }
    
    if (typeof this.maxfiles == "undefined")
    {
      this.maxfiles = "-1";
    }

    if (typeof this.allowed_extensions == "undefined")
    {
      this.allowed_extensions = "";
    }
  },

  computed: {
  },
  methods: {

    Log()
    {
        console.log(this.THUMBNAILS);
        console.log(this.EREDETIDOKLIST);
        console.log(this.KONVERTDOKLIST);
    },

    GetFileNames()
    {
        var res = [];

        for(var i=0; i<this.THUMBNAILS.length; i++)
        {
            var DokIndex = this.THUMBNAILS[i].EredetiDokListIndex;

            res.push({FileName:this.EREDETIDOKLIST[DokIndex].FileNev});
        }

        return res;
    },

    async UploadFiles(pFileTypes, pMakeConvertGreyscale)
    {
        /*
            pFileTypes: 1 - csak az eredeti, 2 - csak a konvertált, 3 - konvertált és eredeti
            4 - pdf eredeti, jpeg konvertált
        */
        var fncres = { UploadID: "", Megjegyzes:this.GetMegjegyzes(), FileCount:0, Success:false };

        var UploadID = await this.$refs.DocUtils.CreateUploadID();
        if (UploadID == "") { return fncres; }

        fncres.UploadID = UploadID;

        fncres.FileCount = this.THUMBNAILS.length;

        var UploadOK = true;

        var CLID = this.EREDETIDOKLIST.length + 100000;

        for(var i=0; i<this.THUMBNAILS.length; i++)
        {
            var DokIndex = this.THUMBNAILS[i].EredetiDokListIndex;

            if (pFileTypes == 4)
            {
                if (this.EREDETIDOKLIST[DokIndex].Kiterjesztes.toLowerCase() == "pdf")
                {
                    var pFiles = [];
                    var pFileItem = {
                        ClientListID:DokIndex+1,
                        ClientListParentID:0,
                        FileName:this.EREDETIDOKLIST[DokIndex].FileNev,
                        Extension:this.EREDETIDOKLIST[DokIndex].Kiterjesztes,
                        Password:this.EREDETIDOKLIST[DokIndex].Jelszo,
                        IsSigned:this.EREDETIDOKLIST[DokIndex].IsSigned,
                        ImageWidth:this.EREDETIDOKLIST[DokIndex].ImageWidth,
                        ImageHeight:this.EREDETIDOKLIST[DokIndex].ImageHeight,
                        DocData:this.EREDETIDOKLIST[DokIndex].DocData,
                    };

                    pFiles.push(pFileItem);

                    if (await this.$refs.DocUtils.UploadFiles(UploadID, pFiles) == false)
                    {
                        UploadOK = false;
                        break;
                    }
                }
                else
                {
                    for(var j=0; j<this.KONVERTDOKLIST.length; j++)
                    {
                        if (this.KONVERTDOKLIST[j].ParentIndex != DokIndex) { continue; }

                        var KonvImgData = "";
                        var KonvImgWidth = 0;
                        var KonvImgHeight = 0;

                        if (pMakeConvertGreyscale)
                        {
                            await this.$refs.DocUtils.Resize(this.KONVERTDOKLIST[j].DocData, "jpg", this.KONVERTDOKLIST[j].ImageWidth, this.KONVERTDOKLIST[j].ImageHeight, true).then(
                                data => {
                                    KonvImgData = data.data;
                                    KonvImgWidth = data.width;
                                    KonvImgHeight = data.height;
                                }
                            );
                        }
                        else
                        {
                            KonvImgData = this.KONVERTDOKLIST[j].DocData;
                            KonvImgWidth = this.KONVERTDOKLIST[j].ImageWidth;
                            KonvImgHeight = this.KONVERTDOKLIST[j].ImageHeight;
                        }

                        CLID++;

                        pFiles = [];
                        pFileItem = {
                            ClientListID:CLID,
                            ClientListParentID:DokIndex+1,
                            FileName:this.KONVERTDOKLIST[j].FileNev,
                            Extension:this.KONVERTDOKLIST[j].Kiterjesztes,
                            Password:"",
                            IsSigned:0,
                            ImageWidth: KonvImgWidth,
                            ImageHeight: KonvImgHeight,
                            DocData: KonvImgData,
                        };

                        pFiles.push(pFileItem);

                        if (await this.$refs.DocUtils.UploadFiles(UploadID, pFiles) == false)
                        {
                            UploadOK = false;
                            break;
                        }

                    }

                }

            } // 4

            if ((pFileTypes == 1) || (pFileTypes == 3))
            {
                var pFiles = [];
                var pFileItem = {
                    ClientListID:DokIndex+1,
                    ClientListParentID:0,
                    FileName:this.EREDETIDOKLIST[DokIndex].FileNev,
                    Extension:this.EREDETIDOKLIST[DokIndex].Kiterjesztes,
                    Password:this.EREDETIDOKLIST[DokIndex].Jelszo,
                    IsSigned:this.EREDETIDOKLIST[DokIndex].IsSigned,
                    ImageWidth:this.EREDETIDOKLIST[DokIndex].ImageWidth,
                    ImageHeight:this.EREDETIDOKLIST[DokIndex].ImageHeight,
                    DocData:this.EREDETIDOKLIST[DokIndex].DocData,
                };

                pFiles.push(pFileItem);

                if (await this.$refs.DocUtils.UploadFiles(UploadID, pFiles) == false)
                {
                    UploadOK = false;
                    break;
                }
            }

            if ((pFileTypes == 2) || (pFileTypes == 3))
            {
                for(var j=0; j<this.KONVERTDOKLIST.length; j++)
                {
                    if (this.KONVERTDOKLIST[j].ParentIndex != DokIndex) { continue; }

                    var KonvImgData = "";
                    var KonvImgWidth = 0;
                    var KonvImgHeight = 0;

                    if (pMakeConvertGreyscale)
                    {
                        await this.$refs.DocUtils.Resize(this.KONVERTDOKLIST[j].DocData, "jpg", this.KONVERTDOKLIST[j].ImageWidth, this.KONVERTDOKLIST[j].ImageHeight, true).then(
                            data => {
                                KonvImgData = data.data;
                                KonvImgWidth = data.width;
                                KonvImgHeight = data.height;
                            }
                        );
                    }
                    else
                    {
                        KonvImgData = this.KONVERTDOKLIST[j].DocData;
                        KonvImgWidth = this.KONVERTDOKLIST[j].ImageWidth;
                        KonvImgHeight = this.KONVERTDOKLIST[j].ImageHeight;
                    }

                    CLID++;
                    
                    pFiles = [];
                    pFileItem = {
                        ClientListID:CLID,
                        ClientListParentID:DokIndex+1,
                        FileName:this.KONVERTDOKLIST[j].FileNev,
                        Extension:this.KONVERTDOKLIST[j].Kiterjesztes,
                        Password:"",
                        IsSigned:0,
                        ImageWidth: KonvImgWidth,
                        ImageHeight: KonvImgHeight,
                        DocData: KonvImgData,
                    };

                    pFiles.push(pFileItem);

                    if (await this.$refs.DocUtils.UploadFiles(UploadID, pFiles) == false)
                    {
                        UploadOK = false;
                        break;
                    }
                }
            }
        } // for i

        fncres.Success = UploadOK;

        return fncres;
    },

    GetMegjegyzes()
    {
        var Szoveg = this.$refs.txtMegjegyzes.GetText();
        Szoveg = Szoveg.replace(/(\r\n)/gm, "<br>");
        Szoveg = Szoveg.replace(/(\n|\r)/gm, "<br>");

        return Szoveg;

        /*
        var res = "<MEGJEGYZES><DocIndex>"+pDocIndex+"</DocIndex>";
        res = res + "<Szoveg><![CDATA["+Szoveg+"]]></Szoveg></MEGJEGYZES>"
        return res;
        */
    },

    GetFileCount()
    {
        return this.THUMBNAILS.length;
    },

    async DeleteFile(pIndex)
    {
        var DialogResult = "";
        var infotext = "Biztosan törli a listából a fájlt?";

        var p = grccomp_dialog_yesno_GetDefaults(grcmain_GetTextBookItem("tech", "megerosites"), infotext);             
        p.height = 200;
        p.width = 400;
        p.padding_top = -1;
        if (grccomp_getScreenSize().width < 400) { p.width = 300; }

        
        await this.$refs.Dialog.ShowDialog(p).then(res => { DialogResult = res; });        

        if (DialogResult != "YES") { return; }


        this.THUMBNAILS.splice(pIndex,1);
    },

    ShowFile(pIndex)
    {
        var DokIndex = this.THUMBNAILS[pIndex].EredetiDokListIndex;

        var docb64 = this.EREDETIDOKLIST[DokIndex].DocData;
        var docfn = this.EREDETIDOKLIST[DokIndex].FileNev; // eredeti fájlnév
        var docdfn = ""; // display fájlnév, ha üres, akkor az eredeti lesz, kiterjesztést ponttal együtt hozzáfűzi

        var docresult = this.$refs.DocDisplayer.ShowFile(docb64, docfn, docdfn);
        //grcmain_ShowFile(docb64, docfn, docdfn);

        if (docresult != "")
        {
            this.ShowInfo(docresult, 200);
        }
        
    },

    async ShowInfo(pText, pHeight)
    {
        var DialogResult = "";
        var p = grccomp_dialog_alert_GetDefaults(grcmain_GetTextBookItem("tech", "informacio"), pText);             
        p.height = pHeight;
        p.width = 400;
        p.padding_top = -1;
        if (grccomp_getScreenSize().width < 400) { p.width = 300; }
        await this.$refs.Dialog.ShowDialog(p).then(res => 
        { 
            DialogResult = res; 
        });               
    },

    async OpenLocalFileDrop(e)
    {
        var dt = e.dataTransfer;
        var flist = dt.files;
        e.preventDefault();

        this.$refs.GRCDB.ShowLoading();

        var pFiles = [];

        this.FILETEMPDOCS = [];
        var self = this;
        for(var i=0; i<flist.length; i++)
        {
            var size = flist[i].size;
            var FileName = flist[i].name.toLowerCase();
            var ext = grcmain_getFileExtension(FileName);
            if (ext == "jpeg") { ext = "jpg"; }

            var item = { ClientListID:i+1, ClientListParentID:0, FileName: FileName, 
            Extension:ext,  DocData: "", Password:"", ImageWidth:0, ImageHeight:0, IsSigned:0 }

            //console.log("i: "+i);
            await this.getBase64(flist[i]).then(
                data => {
                    //console.log("i data: "+data);
                    item.DocData = data.split(',').pop();
                    self.FILETEMPDOCS.push(item);
                    pFiles.push({ size: size })
                    //console.log(item);
                }
            );
        }

        //console.log("PFL: "+pFiles.length);
        await this.LoadFiles(pFiles);
    },

    FileDragOver(e)
    {
        e.preventDefault();
    },

    FileDragLeave(e)
    {

    },

    FileDragStart(e)
    {
        e.dataTransfer.effectAllowed = "all";
        e.dataTransfer.dropEffect = "move";
    },

    async LoadFileFromCode(pFileName, pFileData)
    {
        this.$refs.GRCDB.ShowLoading();

        var pFiles = [];

        this.FILETEMPDOCS = [];
        var self = this;
        //for(var i=0; i<e.target.files.length; i++)
        //{
        pFileName = pFileName.toLowerCase(); //e.target.files[i].name.toLowerCase();
        var ext = grcmain_getFileExtension(pFileName);
        if (ext == "jpeg") { ext = "jpg"; }

        var item = { ClientListID:1, ClientListParentID:0, FileName: pFileName, 
        Extension:ext,  DocData: pFileData, Password:"", ImageWidth:0, ImageHeight:0, IsSigned:0 }
        
        this.FILETEMPDOCS.push(item);

        //pFiles.push({ size: e.target.files[i].size })
        pFiles.push({ size: pFileData.length })

        await this.LoadFiles(pFiles);
    },


    async OpenLocalFile(e)
    {
        this.$refs.GRCDB.ShowLoading();

        var pFiles = [];

        this.FILETEMPDOCS = [];
        var self = this;
        for(var i=0; i<e.target.files.length; i++)
        {
            var FileName = e.target.files[i].name.toLowerCase();
            var ext = grcmain_getFileExtension(FileName);
            if (ext == "jpeg") { ext = "jpg"; }

            var item = { ClientListID:i+1, ClientListParentID:0, FileName: FileName, 
            Extension:ext,  DocData: "", Password:"", ImageWidth:0, ImageHeight:0, IsSigned:0 }

            await this.getBase64(e.target.files[i]).then(
                data => {
                    item.DocData = data.split(',').pop();
                    self.FILETEMPDOCS.push(item);
                    pFiles.push({ size: e.target.files[i].size })
                    //console.log(item);
                }
            );
        }

        await this.LoadFiles(pFiles);
    },

      async LoadFiles(pFiles)
      {
        if (this.FILETEMPDOCS.length == 0)
        {
            this.$refs.GRCDB.HideLoading();
            this.$refs.fileinput.value = "";

            alert("Nincs feltöltendő fájl!");
            return;
        }

        //this.$refs.GRCDB.ShowLoading();

        var FTDLEN = this.FILETEMPDOCS.length;

        let allext = " "+this.allowed_extensions.toLowerCase()+",";

        for(var i=0; i<FTDLEN; i++)
        {
            var ext = this.FILETEMPDOCS[i].Extension;

            /*
            console.log(allext);
            console.log(ext);
            console.log(allext.indexOf(" "+ext.toLowerCase()+","));
            */
            if ((allext.indexOf(" "+ext.toLowerCase()+",") < 0) || (ext == "")) { continue; }
            

            if ((ext == "jpg") || (ext == "png"))
            {
                await this.$refs.DocUtils.Resize(this.FILETEMPDOCS[i].DocData, ext, this.MaxWidth, this.MaxHeight, false).then(
                    data => {
                        this.FILETEMPDOCS[i].DocData = data.data;
                        this.FILETEMPDOCS[i].ImageWidth = data.width;
                        this.FILETEMPDOCS[i].ImageHeight = data.height;
                        this.FILETEMPDOCS[i].Extension = "jpg";
                        this.FILETEMPDOCS[i].FileName = this.FILETEMPDOCS[i].FileName.replace(/(\.png)/gm, ".jpg");
                        this.FILETEMPDOCS[i].FileName = this.FILETEMPDOCS[i].FileName.replace(/(\.jpeg)/gm, ".jpg");

                    }
                );

                // konvert
                
                await this.$refs.DocUtils.Resize(this.FILETEMPDOCS[i].DocData, ext, this.MaxWidth, this.MaxHeight, false).then(
                    data => {
                        let FN = this.FILETEMPDOCS[i].FileName.replace(/(\.jpg)/gm, "_1.jpg");

                        let item = { ClientListID:this.FILETEMPDOCS.length+1, ClientListParentID:this.FILETEMPDOCS[i].ClientListID, FileName: FN, 
                        Extension:"jpg",  DocData: data.data, Password:"", ImageWidth:data.width, ImageHeight:data.height, IsSigned:0 }

                        this.FILETEMPDOCS.push(item);
                    }
                );
                


            } // ext == jpg | png

            if (ext == "pdf")
            {
                var pwdinput = await this.$refs.DocUtils.InputPdfPassword(this.FILETEMPDOCS[i].DocData, this.FILETEMPDOCS[i].FileName);
                if (pwdinput.Sikeres == false)
                {
                    this.$refs.fileinput.value = "";
                    this.$refs.GRCDB.HideLoading();
                    //alert("Nincs megadva jó jelszó, megszakítás...");
                    return;

                }
                this.FILETEMPDOCS[i].Password = pwdinput.Jelszo;
                if (this.$refs.DocUtils.IsPdfSigned()) { this.FILETEMPDOCS[i].IsSigned = 1; }

                // PDF SPLIT
                
                
                if (await this.$refs.DocUtils.SplitPdf(this.FILETEMPDOCS[i].DocData, this.MaxWidth, this.MaxHeight, false, this.FILETEMPDOCS[i].Password) == false) 
                {
                    this.$refs.fileinput.value = "";
                    this.$refs.GRCDB.HideLoading();
                    
                    alert("Hiba a PDF szétbontása során: "+this.FILETEMPDOCS[i].FileName);
                    return;
                }

                var img = this.$refs.DocUtils.GetSplitPdfImages();

                for(let pdfi = 0; pdfi < img.length; pdfi++)
                {
                    let FN = this.FILETEMPDOCS[i].FileName.replace(/(\.pdf)/gm, "_"+(pdfi+1)+".jpg");

                    let item = { ClientListID:this.FILETEMPDOCS.length+1, ClientListParentID:this.FILETEMPDOCS[i].ClientListID, FileName: FN, 
                    Extension:"jpg",  DocData: img[pdfi].data, Password:"", ImageWidth:img[pdfi].width, ImageHeight:img[pdfi].height, IsSigned:0 }

                    this.FILETEMPDOCS.push(item);
                }
                
                // end: PDFSPLIT

            } // ext == pdf

        } // end: for i


        let FTDL = this.FILETEMPDOCS.length;
        for(var i=0; i<FTDL; i++)
        {
            if (this.FILETEMPDOCS[i].ClientListParentID == 0)
            {
                if ((this.THUMBNAILS.length >= parseInt(this.maxfiles)) && (parseInt(this.maxfiles) >=0)) { break; }

                var item = 
                { ID:0, Kep_ID:0, FileNev: this.FILETEMPDOCS[i].FileName, 
                Kiterjesztes:this.FILETEMPDOCS[i].Extension, Jelszo:this.FILETEMPDOCS[i].Password, 
                DocData: this.FILETEMPDOCS[i].DocData, IsSigned: this.FILETEMPDOCS[i].IsSigned,
                ImageWidth: this.FILETEMPDOCS[i].ImageWidth, ImageHeight: this.FILETEMPDOCS[i].ImageHeight,
                };     

                this.EREDETIDOKLIST.push(item);

                let ParentIndex = this.EREDETIDOKLIST.length-1;


                let ThumbnailDone = false;
                let FTDL2 = this.FILETEMPDOCS.length;
                for(var j=0; j<FTDL2; j++)
                {
                    if (this.FILETEMPDOCS[j].ClientListParentID == this.FILETEMPDOCS[i].ClientListID)
                    {
                        var item = 
                        { ID:0, ParentIndex:ParentIndex, Kep_ID:0, FileNev: this.FILETEMPDOCS[j].FileName, 
                        Kiterjesztes:this.FILETEMPDOCS[j].Extension, Jelszo:"", 
                        DocData: this.FILETEMPDOCS[j].DocData, IsSigned: 0,
                        ImageWidth: this.FILETEMPDOCS[j].ImageWidth, ImageHeight: this.FILETEMPDOCS[j].ImageHeight,
                        };     

                        this.KONVERTDOKLIST.push(item);

                        if (ThumbnailDone == false)
                        {
                            if (this.FILETEMPDOCS[i].Extension == "jpg")
                            {
                                await this.$refs.DocUtils.Resize(this.FILETEMPDOCS[i].DocData, this.FILETEMPDOCS[i].Extension, this.ThumbnailWidth, this.ThumbnailHeight, false).then(
                                    data => {
                                        let thumbitem = { EredetiDokListIndex:ParentIndex, FileName:this.FILETEMPDOCS[i].FileName, Img:"data:image/jpeg;base64," + data.data, 
                                        FileSize:grcmain_GetFileSizeString(pFiles[i].size), }

                                        this.THUMBNAILS.push(thumbitem);
                                    }
                                );
                            }
                            else
                            {
                                await this.$refs.DocUtils.Resize(this.FILETEMPDOCS[j].DocData, this.FILETEMPDOCS[j].Extension, this.ThumbnailWidth, this.ThumbnailHeight, false).then(
                                    data => {
                                        let thumbitem = { EredetiDokListIndex:ParentIndex, FileName:this.FILETEMPDOCS[i].FileName, Img:"data:image/jpeg;base64," + data.data, 
                                        FileSize:grcmain_GetFileSizeString(pFiles[i].size), }

                                        this.THUMBNAILS.push(thumbitem);
                                    }
                                );
                            }



                            ThumbnailDone = true;
                        }

                    }
                }


            } // parentid = 0
        }


        this.$refs.fileinput.value = "";

        this.$refs.GRCDB.HideLoading();

      },

    async getBase64(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    },

    async LoadLocalFile(pFile, pClientListID)
    {
        var self = this;

        //var size = grcmain_GetFileSizeString(pFile.size);

        var FileName = pFile.name.toLowerCase();
        var ext = grcmain_getFileExtension(FileName);
        if (ext == "jpeg") { ext = "jpg"; }

        var item = { ClientListID:pClientListID, ClientListParentID:0, FileName: FileName, 
        Extension:ext,  DocData: "", Password:"", ImageWidth:0, ImageHeight:0, IsSigned:0 }

        await this.getBase64(pFile).then(
            data => {
                item.DocData = data.split(',').pop();
                self.FILETEMPDOCS.push(item);
                //console.log(item);
            }
        );
    },


  }
}
</script>

<style scoped>

.compcont
{
  width:100%;
  box-sizing: border-box;
  font-family: 'CmsDefault';
  font-size:14px;
  line-height: 18px;
  color:#444;
}

.btncont
{
  width:100%;
  box-sizing: border-box;
  text-align: center;
}


.btn
{
  display: inline-block;
  font-size: 15px;
  line-height: 16px;
  font-family: 'CmsDefault';
  font-weight: normal;
  text-align: center;  
  background-color:var(--themecolor3);
  color:#fff;
  padding:10px 15px;
  cursor:pointer;
  border-radius: 15px;
  margin: 2px;
  min-width: 120px;

}

.btn:hover
{
  opacity:0.8;
}

.btn_icon
{
    margin-right:4px;
}

.btn_text
{
    display:inline;
}

.btn_gray
{
    background-color: #ddd;
    color: #444;;
}

.btn_gray:hover
{
    opacity:0.8;
}

.filelist_cont {
    width: 100%;
    box-sizing: border-box;
    font-family: "CmsDefault";
    font-size: 15px;
    line-height: 18px;    
    color: #000;
    display: inline-block;
    border-bottom: solid 0px #ccc;
    padding-bottom: 4px;
    margin-bottom: 4px;
    text-align: center;
}

.file_for 
{
    width: 310px;
    box-sizing: border-box;
    display: inline-block;
    border:solid 1px #ccc;
    border-radius: 2px;
    margin:5px;
    box-shadow: rgb(221, 221, 221) 2px 2px 4px;
    position: relative;
    vertical-align: top;
    height: 262px;    
    background-color: #fff;
}

.file_for:hover
{
    background-color: #fff;
}

.file_for_drag
{
    width: 310px;
    box-sizing: border-box;
    display: inline-block;
    border-radius: 3px;
    margin:5px;
    position: relative;
    background-color: #f6f6f6;
    vertical-align: top;
    height: 262px;    

    border: dashed 2px #ccc;
}

.file_for_drag:hover
{
    border: dashed 2px #888;
}

.drag_text
{
    width:100%;
    box-sizing: border-box;
    height:200px; 
    text-align:center;    
    font-family: "CmsDefault";
    font-size: 15px;
    line-height: 18px;    
    padding:20px 10px;
    color:#888;
}

.file_thumb
{
    width: 100%;
    cursor:pointer;
    text-align: center;
    padding: 5px;
    width:300px;
    height:220px;
    position: relative;
}

.file_footer
{
    width: 100%;
    box-sizing: border-box;
    background-color: #f0f0f0;
    border-top:solid 1px #ccc;
    height: 40px;
    padding:4px;
}

.file_filename
{
    width: 100%;
    box-sizing: border-box;
    font-size: 13px;
    line-height: 16px;
    text-align: left;
    text-overflow: ellipsis;
    white-space: nowrap;    
    overflow: hidden;
}

.file_filesize
{
    width: 100%;
    box-sizing: border-box;
    font-size: 13px;
    line-height: 16px;
    text-align: left;
    text-overflow: ellipsis;
    white-space: nowrap;    
    overflow: hidden;
}

.file_delete
{
    width:30px;
    background-color: var(--themecolor3);
    color: #fff;
    position:absolute;
    right:-1px;
    top:-1px;
    text-align: center;
    padding: 8px;
    font-size: 16px;
    line-height: 16px;
    border-radius: 2px;
    cursor:pointer;
    z-index: 500;
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
}

.file_delete:hover
{
    opacity:0.8;
}

.file_pass_cont
{
    width:100%;
    box-sizing: border-box;
    padding:0px 4px;
    padding-bottom: 2px;
    position: absolute;
    bottom: 40px;    
}

.file_pass_label
{
    width:100%;
    box-sizing: border-box;
    font-family: 'CmsDefault';
    font-size: 12px;
    line-height: 12px;
    font-weight: 500;
    color:#222;
    text-align: left;
    padding-bottom: 2px;
}

@media (max-width:670px)
{
    .filelist_cont
    {
        text-align: center;
    }

    .btncont
    {
        text-align: center;   
    }
}

</style>